import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/no-array-index-key */
import { isTwoColumn } from '@outdoor-voices/ui/dist/utils/dom/isMobile';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import CollectionFilters from '../CollectionFilters';
import css from './SearchResults.module.scss';
import Image from '../Image';
import Price from '../Price';
import ResultsListEmpty from '../ResultsListEmpty';
import sorts from './sorts';
import updateArray from '../../utils/array/update';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var filterAndSort = function filterAndSort(_ref) {
  var results = _ref.results,
      filters = _ref.filters,
      sort = _ref.sort;

  // Filter results by the selected filters
  var filteredProducts = _toConsumableArray(results);

  filters.forEach(function (filt) {
    if (!filt.selected) {
      return;
    }

    filteredProducts = filteredProducts.filter(function (result) {
      return filt.filter(result, filt.selected.value);
    });
  }); // Apply our sort

  if (sort && sort.sort) {
    filteredProducts = filteredProducts.sort(sort.sort);
  }

  return filteredProducts;
};

var SearchResults = function SearchResults(_ref2) {
  var displaySort = _ref2.displaySort,
      results = _ref2.results,
      initialFilters = _ref2.filters,
      searchTerms = _ref2.searchTerms;

  var _useState = useState(initialFilters),
      _useState2 = _slicedToArray(_useState, 2),
      filters = _useState2[0],
      setFilters = _useState2[1];

  var _useState3 = useState(sorts[0]),
      _useState4 = _slicedToArray(_useState3, 2),
      sort = _useState4[0],
      setSort = _useState4[1];

  var rootEl = useRef(null);
  var cols = isTwoColumn() ? 2 : 3;

  var scrollToTop = function scrollToTop() {
    window.scrollTo(0, rootEl.current.offsetTop - 72);
  };

  var onFilterSelect = function onFilterSelect(filter, _ref3) {
    var value = _ref3.value;
    var newFilters = updateArray(filters, filters.indexOf(filter), {
      selected: filter.selected && filter.selected.value === value ? false : {
        label: value,
        value: value
      }
    });
    setFilters(newFilters);
    scrollToTop();
  };

  var onSortSelect = function onSortSelect(_ref4) {
    var value = _ref4.value;
    var newSort = sorts.find(function (srt) {
      return srt.value === value;
    });
    setSort(newSort);
    scrollToTop();
  };

  var onFilterClear = function onFilterClear() {
    var newFilters = filters.reduce(function (arr, filter) {
      return arr.concat(_objectSpread(_objectSpread({}, filter), {}, {
        selected: false,
        value: ''
      }));
    }, []);
    setFilters(newFilters);
    scrollToTop();
  };

  var actualResults = filterAndSort({
    results: results,
    filters: filters,
    sort: sort
  });
  var row = Math.floor(actualResults.length / cols);
  var extra = cols - (actualResults.length - row * cols);
  useEffect(function () {
    document.title = "Search results for '".concat(searchTerms, "' \u2013 Outdoor Voices");
    var statusEl = document.getElementById('status');

    if (statusEl) {
      statusEl.focus();
    }
  }, [actualResults, searchTerms]);
  return /*#__PURE__*/_jsxs("div", {
    ref: rootEl,
    children: [/*#__PURE__*/_jsx("h1", {
      className: "ada-hidden",
      children: "Search Results"
    }), /*#__PURE__*/_jsx(CollectionFilters, {
      clearFilters: onFilterClear,
      displaySort: displaySort,
      filtered: filters.find(function (filt) {
        return filt.selected;
      }) !== undefined,
      filters: filters,
      filterSelect: onFilterSelect,
      sort: sort,
      sorts: sorts,
      sortSelect: onSortSelect
    }), /*#__PURE__*/_jsx("span", {
      id: "status",
      "aria-live": "polite",
      className: "ada-hidden",
      role: "status",
      tabIndex: 0,
      children: "".concat(actualResults.length, " Result").concat(actualResults.length === 1 ? '' : 's', " Found")
    }), actualResults.length === 0 && /*#__PURE__*/_jsx(ResultsListEmpty, {
      onClear: onFilterClear
    }), /*#__PURE__*/_jsxs("ul", {
      className: css.root,
      children: [actualResults.map(function (_ref5) {
        var color = _ref5.color,
            id = _ref5.id,
            image = _ref5.image,
            price = _ref5.price,
            category = _ref5.category,
            subtitle = _ref5.collection_subtitle,
            title = _ref5.title,
            url = _ref5.url;
        return /*#__PURE__*/_jsx("li", {
          className: css.item,
          children: /*#__PURE__*/_jsx("article", {
            className: css.product,
            children: /*#__PURE__*/_jsxs("a", {
              className: css.link,
              href: url,
              children: [/*#__PURE__*/_jsx("div", {
                className: css.image,
                children: /*#__PURE__*/_jsx(Image, {
                  alt: "".concat(title, " in the color ").concat(color),
                  src: image
                })
              }), /*#__PURE__*/_jsxs("h2", {
                className: css.title,
                children: [/*#__PURE__*/_jsx("span", {
                  children: title
                }), "\xA0", category !== 'Gift Certificate' && /*#__PURE__*/_jsx(Price, {
                  price: price
                }, price)]
              }), subtitle && /*#__PURE__*/_jsx("div", {
                children: /*#__PURE__*/_jsx("em", {
                  children: subtitle
                })
              })]
            })
          })
        }, id);
      }), Array(extra).fill(0).map(function (_, idx) {
        return /*#__PURE__*/_jsx("li", {
          className: css.item
        }, idx);
      })]
    })]
  });
};

SearchResults.propTypes = {
  displaySort: PropTypes.bool.isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  results: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  searchTerms: PropTypes.string.isRequired
};
export default SearchResults;